import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';

export class ExclusionListSelectorBaseDataProvider extends BaseWebComponentDataProvider {
  async getExclusionList(companyId, type, extraParams): Promise<any> {
    throw new Error('Not implemented');
  }
}
